// دالة لتحويل الأرقام الإنجليزية إلى أرقام هندية (عربية)
export const toArabicNumbers = (input: string | number): string => {
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  
  // تحويل الرقم إلى نص إذا كان رقم
  const str = typeof input === 'number' ? input.toString() : input;
  
  // استبدال كل رقم إنجليزي برقم هندي
  return str.replace(/\d/g, (digit) => arabicNumerals[parseInt(digit)]);
};

// دالة لتحويل التواريخ إلى أرقام هندية
export const formatDateWithArabicNumbers = (date: Date, format?: string): string => {
  const formattedDate = date.toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  return toArabicNumbers(formattedDate);
};

// دالة لتحويل النسب المئوية إلى أرقام هندية
export const formatPercentageWithArabicNumbers = (percentage: number): string => {
  return `${toArabicNumbers(Math.round(percentage))}%`;
};

// دالة لتحويل الأرقام مع فواصل الآلاف إلى أرقام هندية
const formatNumberWithArabicNumbers = (number: number): string => {
  const formattedNumber = number.toLocaleString('ar-SA');
  return toArabicNumbers(formattedNumber);
};

// دالة لتحويل العد إلى أرقام هندية
export const formatCountWithArabicNumbers = (count: number): string => {
  return toArabicNumbers(count);
};